"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = void 0;

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var Parameters_1 = require("./Parameters");

exports.defaultOptions = {
  sid: '',
  env: Parameters_1.Env.Prod,
  pluginCheckPeriod: 3000,
  toolboxBrowsers: [],
  userActivityPeriod: 60000,
  addToTrustedLink: 'https://help.kontur.ru/content/components/AddToTrusted_User.exe',
  pluginInstallLink: 'https://help.kontur.ru/plugin/',
  installDiskLink: 'https://install.kontur.ru?fast',
  installPluginOnNewTab: false,
  unsupportedBrowsers: [],
  supportedOperationSystems: [],
  minPluginVersion: '3.0.0',
  certificatesFetchPeriod: 120000,
  storeNames: [Plugin_1.StoreName.My],
  storeTypes: [Plugin_1.StoreType.CryptoApi, Plugin_1.StoreType.Pkcs11, Plugin_1.StoreType.Requisite],
  hasPrivateKey: true,
  fetchCertificatesWithContent: true,
  saveDefaultCertOrder: false,
  ignoreNoCertificatesByFilterError: false,
  validIssuers: [],
  blacklist: [],
  localTimeShift: 0,
  warnBeforeExpiringPeriod: 30,
  showCertAfterExpiringPeriod: 0,
  showNotCabucCertAfterExpiringPeriod: 0,
  showSearchCertCount: 5,
  wide: false,
  view: Parameters_1.CertificatesListView.Inline,
  selectable: false,
  showInnKppPrefix: false,
  loaderShowDelay: 200,
  requisiteCertificateTypes: [Plugin_1.CertificateType.Cloud],
  pageSize: 20,
  showLoader: false
};